import { useEffect, useState } from "react";
import ManageAgent from "../agent/ManageAgent";
import ChatBoxConfigurationForm from "../../components/ui/ChatBoxConfigurationForm";
import LeadScoringForm from "../../components/leads/LeadScoringForm";
import StepIndicator from "../../components/ui/StepIndicator";
import Card from "../../components/ui/Card";

import "../../styles/register.css";

import AgentBasicInfoSection from "../../components/agents/AgentBasicInfoSection";

import { initialLeadData } from "../../data/intialData";

import { useAgentStore } from "../../store/agentStore";

import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import {useWidgetSettings} from "../../hooks/useWidgetSettings";

import { useCreateScoringMutation } from "../../queries/useScoringConfigQuery";

function SetupWizard() {
  const [currentStep, setCurrentStep] = useState(0);

  const navigate = useNavigate();

  const { selectedAgent, clearSelectedAgent } = useAgentStore();
  const agentId = selectedAgent?.agent?.id;

  useEffect(() => {
    clearSelectedAgent();
  }, [clearSelectedAgent]);

  const handleWidgetSettingsSuccess = () => {
    navigate(`/agents/${agentId}`);
  };

const { handleManageWidgetSettings, isLoading: isManageWidgetSettingsPending } = useWidgetSettings(selectedAgent?.agent?.id, handleWidgetSettingsSuccess);

  const { mutate: createScoringMutation, isPending: isCreateScoringPending } = useCreateScoringMutation();
 



  const nextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const handleAgentSuccess = () => {
    nextStep();
  };



  const handleLeadSubmit = (data) => {

    if(!agentId) {
      toast.error("Agent ID is required");
      return;
    };
    createScoringMutation({
      id: agentId,
      data: data,
    }, {
      onSuccess: () => {
    
        toast.success("Lead scoring updated successfully");
        nextStep();
      },
      onError: (error) => {
        toast.error(error.message);
      },
    });
  };
 


  // Step configuration
  const steps = [
    {
      title: "Create Agent",
      component: (
        <ManageAgent onSuccess={handleAgentSuccess}  />
      ),
    },
    {
      title: "Lead Scoring",
      component: (
        <div className="register-lead-scoring-form-box scroll-y-auto scroll-bar-hidden">
        <LeadScoringForm
          initialValues={initialLeadData}
          onSubmit={handleLeadSubmit}
          isLoading={isCreateScoringPending}
        />
        </div>
      ),
    },
    {
      title: "Chatbox Configuration",
      component: (
        <ChatBoxConfigurationForm
          chatboxSettings={selectedAgent?.settings}
          onSubmit={handleManageWidgetSettings}
          isLoading={isManageWidgetSettingsPending}
        />
      ),
    },
  ];

  const CurrentComponent = steps[currentStep];

  return (
    <div className="page-container">
      <section className="register-container scroll-auto scroll-bar-hidden">
      {currentStep > 0 && <AgentBasicInfoSection />}
      <h1 className="page-title">CRM System Setup</h1>

      <div className="d-flex flex-column align-center w-100">
        <StepIndicator
          currentStep={currentStep + 1}
          totalSteps={steps.length}
        />

        <div className="d-flex justify-center w-100">
          <Card className="w-100 p-4">
            <h2 className="text-primary mb-3">{CurrentComponent.title}</h2>
            {CurrentComponent.component}
          </Card>
        </div>
      </div>
      </section>
    </div>
  );
}

export default SetupWizard;
